export default __webpack_public_path__ + "static/media/values-at-our-core.af62b73b.svg";